'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/iterator');

require('core-js/fn/array/find-index');

require('core-js/fn/map');

require('core-js/fn/string/starts-with');

require('core-js/fn/string/includes');

require('core-js/fn/symbol');


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/utils/polyfills.js
// module id = 940
// module chunks = 0